import { fromJS } from 'immutable';

import { SWITCH_ORGANIZATION, SWITCH_ORGANIZATION_FAILED } from './constants';

export const initialState = fromJS({
  updating: false,
  error: false,
});

export default (state = initialState, action: any) => {
  switch (action.type) {
    case SWITCH_ORGANIZATION:
      return state.set('updating', true);

    case SWITCH_ORGANIZATION_FAILED:
      return state.merge({ loading: false, error: action.error });

    default:
      return state;
  }
};
